<template>
  <div>
    <div class="modal-body d-flex flex-column gap-20">
      <div class="d-flex flex-column gap-5">
        <h2>{{ 'Thank you for your feedback!' | trans }}</h2>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn close-btn" @click.prevent="close">
        <i class="fa fa-times mr-1"></i><strong>{{ 'Close' | trans }}</strong>
      </button>
    </div>
  </div>
</template>
<script>
import store from '../../../mixins/store.mixin';

export default {
  name: 'FeedbackSentModal',
  props: {},
  components: {},
  mixins: [store],
  data() {
    return {};
  },
  methods: {
    close() {
      $('#FeedbackModal').modal('hide');
    },
  },
  computed: {},
};
</script>
